module.exports = __webpack_public_path__ + "static/img/206.c6ff48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/206.png
// module id = 505
// module chunks = 3